import React from 'react';
import PropTypes from 'prop-types';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Flag from '@zg-rentals/multibrand-ui/lib/icons/Flag';

export default class Contact extends React.Component {
    static propTypes = {
        name: PropTypes.string.isRequired,
        date: PropTypes.string.isRequired,
        reportSpam: PropTypes.func.isRequired,
    };

    constructor() {
        super();
        this.redirectToProperties = this.redirectToProperties.bind(this);
        this.decrementSecond = this.decrementSecond.bind(this);

        this.state = {
            redirectTimeout: setTimeout(this.redirectToProperties, 3000),
            timerInterval: setInterval(this.decrementSecond, 1000),
            time: 3,
        };
    }

    componentDidMount() {
        this.props.reportSpam();
    }

    componentWillUnmount() {
        clearTimeout(this.state.redirectTimeout);
        clearInterval(this.state.timerInterval);
    }

    decrementSecond() {
        this.setState(prevState => ({
            time: prevState.time - 1,
        }));
    }

    redirectToProperties() {
        window.router.transitionTo('/rental-manager/properties');
    }

    render() {
        const { name, date } = this.props;
        const { time } = this.state;
        const spamText = `Message from ${name} on ${date} marked as spam.`;
        const redirectText = `Thanks! We are redirecting you to your properties in ${time} seconds...`;

        return (
            <Row>
                <Col>
                    <div className="Inquiry-contact-spam">
                        <div className="Inquiry-contact-spamicon">
                            <Flag colorType="text-secondary" />
                        </div>
                        <div>
                            <Text className="Inquiry-contact-spamtext" type="h3" danger={true}>
                                {spamText}
                            </Text>
                            <Text>{redirectText}</Text>
                        </div>
                    </div>
                </Col>
            </Row>
        );
    }
}
